import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import { DropoutsReportHeader } from "../components/HeaderAttribute";
import * as XLSX from "sheetjs-style";
import jsPDF from "jspdf";
import "jspdf-autotable";
import fpaiLogo from "../image/FPAILogo.jpg";
import MultiSelect from "../ReusableComponents/MultiSelect";
import { useUserCapability } from "../components/ConstantReducerProvider";
import ReportGridPage from "../components/ReportGridPage";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import Loader from "../ReusableComponents/Loader";

const DropOutsReport = () => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [branchProject, setBranchProject] = useState("");
  const [branchName, setBranchName] = useState("");
  const [sdp, setSDP] = useState("");
  const [branchProjectError, setBranchProjectError] = useState("");
  const [sdpError, setSDPError] = useState("");
  const [area, setArea] = useState("");
  const [areaError, setAreaError] = useState("");
  const [bindBranchProjectDD, setBindBranchProjectDD] = useState([]);
  const [bindDropoutData, setBindDropoutData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [getSDPDatas, setGetSDPDatas] = useState([]);
  const [bindSDP, setBindSDP] = useState([]);
  const [project, setProject] = useState(0);
  const [project1, setProject1] = useState('');
  const [projectError, setProjectError] = useState("");
  const [bindProject, setBindProject] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [getAreaDatas, setGetAreaDatas] = useState([]);
  const [bindArea, setBindAreaDD] = useState([]);

  const [branchProjectNamesList, setBranchProjectNamesList] = useState([]);
  const [sdpNamesList, setSDPNamesList] = useState([]);
  const [areaNamesList, setAreaNamesList] = useState([]);

  useEffect(
    () => {
      if (branchProject) {
        try {
          const getSelectedSDP = async () => {
            const userProfileDatas = userProfileState.userProfile;
            const [profile] = userProfileDatas;
            const data = {
              mstOrganizationStructureId: profile.MstOrganizationId,
              mstBranchId: profile.MstLocationId,
              mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
              mstUserId: profile.MstUserId,
              mstRoleId: profile.MstRoleId,
              languageCode: "en",
            };
            const locationResponse = await BindPostAPI([data], "SDPAPI/GetSDP");
            setGetSDPDatas(locationResponse.data.Table);

            if (userProfileDatas && userProfileDatas[0]) {
              const sdpLabels = locationResponse.data.Table.filter((item) =>
                branchProject.includes(parseInt(item.MstLocationId))
              ).map((item) => ({
                MstSDPId: item.MstSDPId,
                SDP_en: item.SDP_en,
              }));

              const sdpSelected = sdpLabels.map((SD) => ({
                value: SD.MstSDPId,
                label: SD.SDP_en,
              }));

              if (
                userProfileDatas[0].MstOrganizationId == 1 ||
                userProfileDatas[0].MstOrganizationId == 2
              ) {
                setBindSDP(sdpSelected);
              } else {
                const allSDPIds = userProfileDatas[0]?.AllSDP;
                const sdpId = userProfileDatas[0]?.MstSDPId;

                if (allSDPIds && Array.isArray(allSDPIds)) {
                  const filteredSdpSelected = sdpSelected.filter((sdp) =>
                    allSDPIds.includes(sdp.value)
                  );
                  setBindSDP(filteredSdpSelected);
                }
                if (sdpId) {
                  setBindSDP([]);
                  const filteredSdpSelected = sdpSelected.filter((sdp) =>
                    Array.isArray(sdpId)
                      ? sdpId.includes(sdp.value)
                      : sdpId === sdp.value
                  );
                  setBindSDP(filteredSdpSelected);
                }
              }
            }
          };

          getSelectedSDP();
        } catch (e) {
        }
      }
    },
    [branchProject ? branchProject : undefined],
    userProfileDatas ? userProfileDatas : undefined
  );
  useEffect(() => {
    if (sdp) {
      try {
        const getSelectedArea = async () => {
          const userProfileDatas = userProfileState.userProfile;
          const [profile] = userProfileDatas;
          const data = {
            mstOrganizationStructureId: profile.MstOrganizationId,
            mstBranchId: profile.MstLocationId,
            mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
            mstUserId: profile.MstUserId,
            mstRoleId: profile.MstRoleId,
            languageCode: "en",
          };
          const locationResponse = await BindPostAPI([data], "AreaAPI/GetArea");
          setGetAreaDatas(locationResponse.data.Table);

          const areaLabels = locationResponse.data.Table.filter((item) =>
            sdp.includes(item.MstSDPId)
          ).map((item) => ({
            MstAreaId: item.MstAreaId,
            AreaName_en: item.AreaName_en,
          }));

          const areaSelected = areaLabels.map((AR) => ({
            value: AR.MstAreaId,
            label: AR.AreaName_en,
          }));

          setBindAreaDD(areaSelected);
        };

        getSelectedArea();
      } catch (e) {
      }
    }
  }, [sdp ? sdp : undefined]);

  useEffect(() => {
    if (
      userProfileDatas[0]?.MstOrganizationId == 2 ||
      userProfileDatas[0]?.MstOrganizationId == 3
    ) {
      if (userProfileDatas[0]?.MstSDPId == null) {
        setBranchName(userProfileDatas[0]?.LocationName_en);
        setBranchProject([userProfileDatas[0]?.MstLocationId]);
        setSDP("");
      } else {
        setBranchName(userProfileDatas[0]?.LocationName_en);
        setBranchProject([userProfileDatas[0]?.MstLocationId]);
        setSDP([userProfileDatas[0]?.MstSDPId]);
      }
    }
    BranchProjectFetchData();

    fetchAllDropdowns();
  }, [userProfileDatas ? userProfileDatas : undefined]);

  const fetchAllDropdowns = useCallback(async () => {

    try {
      // 🔹 Run APIs in parallel
      const userProfileDatas = userProfileState.userProfile;
      const [profile] = userProfileDatas;
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };
      const [locationRes, pacServicesRes] = await Promise.all([
        BindAPI("TXNServicesAPI/ServicesDatas"),
        BindPostAPI([data], "ServicesMasterAPI/BindServicesDropDowns"),
      ]);

      const locData = locationRes.data || {};
      const pacData = pacServicesRes.data || {};

      // 🔹 Extract tables once
      const tables = {
        location: locData.Table2 ?? [],
        area: locData.Table ?? [],
        brand: locData.Table6 ?? [],
        serviceSub: locData.Table5 ?? [],
        services: locData.Table9 ?? [],
        project: locData.Table3 ?? [],
        serviceCategory: locData.Table4 ?? [],
        referredTo: locData.Table8 ?? [],
        pacServices: pacData.Table1 ?? [],
        appointmentWith: locData.Table1 ?? [],
      };

      // 🔹 Filter project by MstBranchProjectId & user organization
      const userOrgId = userProfileDatas[0]?.MstLocationId;

      tables.project =
        userOrgId == null || userOrgId === 0
          ? tables.project
          : tables.project.filter(
            (item) => item.MstBranchProjectId === userOrgId
          );

      // 🔹 Reusable mapper
      const toOptions = (arr = [], valueKey, labelKey, { filterBlocked = false } = {}) =>
        arr
          .filter(item => !filterBlocked || item.BlockedBy == null)
          .map(item => ({ value: item[valueKey], label: item[labelKey] }));

      // 🔹 Prepare dropdowns
      const dropdowns = {
        bindSDPDD: toOptions(tables.appointmentWith, "MstSDPId", "SDP_en"),
        bindArea: toOptions(tables.area, "MstAreaId", "AreaName_en"),
        bindProject: toOptions(tables.project, "MstProjectId", "ProjectName_en"),
        bindServiceCategory: toOptions(
          tables.serviceCategory,
          "MstServicesCategoryId",
          "ServicesCategory_en"
        ),
        bindReferralDD: toOptions(tables.referredTo, "MstReferredToId", "ReferredTo_en"),
        bindPACServices: toOptions(tables.pacServices, "MstPACServicesId", "PACServices"),
      };

      // 🔹 User-specific SDP dropdown
      const { MstSDPId: userSDPId, MstLocationId: userLocationId } = userProfileDatas[0] || {};
      dropdowns.bindUserSDPDD = tables.appointmentWith
        .filter(item =>
          userSDPId ? item.MstSDPId == userSDPId : item.MstLocationId == userLocationId
        )
        .map(item => ({ value: item.MstSDPId, label: item.SDP_en }));

      setBindProject(dropdowns.bindProject);
    } catch (err) {
      console.error("Error fetching dropdown data:", err);
    } finally {
    }
  }, [userProfileDatas]);

  const GoButton = async () => {
    setIsLoading(true);

    const branchProjectValidate = branchProject ? "" : "Select Branch/Project";
    setBranchProjectError(branchProjectValidate);

    const sdpValidate = sdp ? "" : "Select SDP";
    setSDPError(sdpValidate);

    const areaValidate = area ? "" : "Select Area";
    setAreaError(areaValidate);

    let branchArray = Array.from(
      { length: branchProject.length },
      (v, i) => branchProject[i]
    );
    let branchResult = branchArray.join(",");

    let sdpArray = Array.from({ length: sdp.length }, (v, i) => sdp[i]);
    let sdpResult = sdpArray.join(",");

    let areaArray = Array.from({ length: area.length }, (v, i) => area[i]);
    let areaResult = areaArray.join(",");

    if (!branchProjectValidate && !sdpValidate && !areaValidate) {
      const ReportData = [
        {
          mstBranchId: branchResult,
          mstSDPId: sdpResult,
          mstAreaId: areaResult,
          mstProjectId: project ?? 0,
          fromDate: fromDate,
          toDate: toDate,
        },
      ];
      const response = await BindPostAPI(
        ReportData,
        "NotificationAPI/ReportDropOuts"
      );
      setBindDropoutData(response.data.Table);
      setShowTable(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const automaticFromDate = `${currentYear}-01-01`;
    setFromDate(automaticFromDate);

    const formattedToDate = today.toISOString().split("T")[0];
    setToDate(formattedToDate);
  }, []);



  const createdBy = sessionStorage.getItem("createdBy");



  const handleExport = async () => {

    try {
      const dateRange = {
        fromDate: fromDate,
        toDate: toDate,
      };

      const selectedOptionsData = {
        branchProjectData:
          branchProjectNamesList.length > 0
            ? branchProjectNamesList.toString()
            : branchName,
        sdpData: sdpNamesList.toString(),
        areaData: areaNamesList.toString(),
      };

      // Export Function
      await exportData(
        DropoutsReportHeader.map(
          (column) => column.title
        ),
        bindDropoutData,
        dateRange,
        selectedOptionsData
      );

      // ✅ Success Log
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: `Dropouts Report`,
          action: "Excel Export",
          status: "SUCCESS",
          tableName: null,
          description: `Dropouts Report Excel exported successfully, From ${fromDate} to ${toDate}`,
        },
        "Log/IUDLog"
      );

      console.log(
        "Dropouts Report Excel export completed successfully"
      );
    } catch (error) {
      console.error(
        "Dropouts Report Excel export failed:",
        error
      );

      // ❌ Failed Log
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: `Dropouts Report`,
          action: "Excel Export",
          status: "FAILED",
          tableName: null,
          description: `Dropouts Report Excel export failed - ${error?.message || "Unknown Error"
            }`,
        },
        "Log/IUDLog"
      );
    }
  };
  const exportData = (columns, rows, dateRange, selectedDetails) => {
    const safe = (val) => (val === null || val === undefined ? "" : val);
    /* ================= HEADER STYLES ================= */
    const BLUE_HEADER = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "2D2D6E" } },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
    };

    const DARK_HEADER = {
      ...BLUE_HEADER,
      fill: { fgColor: { rgb: "3A3A3A" } },
    };


    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "Drop outs",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];


    /* ================= DATE FORMAT ================= */
    const formatDate = (dateStr) => {
      if (!dateStr) return "";

      const d = new Date(dateStr);

      return `${String(d.getDate()).padStart(2, "0")}-${String(
        d.getMonth() + 1
      ).padStart(2, "0")}-${d.getFullYear()}`;
    };


    /* ================= DATE RANGE ================= */
    const dateRangeRow = [
      { v: "" },
      {
        v: "From Date:",
        s: { font: { bold: true } },
      },
      {
        v: formatDate(dateRange.fromDate),
      },
      {
        v: "To Date:",
        s: { font: { bold: true } },
      },
      {
        v: formatDate(dateRange.toDate),
      },
    ];


    /* ================= FILTER INFO ================= */
    const branchRow = [
      { v: "" },

      {
        v: "Branch:",
        s: { font: { bold: true } },
      },

      {
        v: selectedDetails.branchProjectData,
        s: { alignment: { wrapText: true } },
      },

      {
        v: "Project:",
        s: { font: { bold: true } },
      },

      {
        v: project1,
        s: { alignment: { wrapText: true } },
      },

      {
        v: "S.D.P.:",
        s: { font: { bold: true } },
      },

      {
        v: selectedDetails.sdpData,
        s: { alignment: { wrapText: true } },
      },

      {
        v: "Area:",
        s: { font: { bold: true } },
      },

      {
        v: selectedDetails.areaData,
        s: { alignment: { wrapText: true } },
      },
    ];


    /* ================= SPACING ================= */
    const spacingRow = [
      { v: "" }
    ];


    /* =========================================================
       HEADER ROW 1
       
       REMOVED:
           Row Total
       
       Remaining columns:
           0  S.No.
           1  Branch
           2  Project
           3  SDP
           4  Area
           5  Contraception Methods
           6  Reasons for Drop Outs
           12 Switched Method
           19 Total
       ========================================================= */

    const headerRow1 = [

      { v: "S.No.", s: BLUE_HEADER },                 // 0
      { v: "Branch", s: BLUE_HEADER },                // 1
      { v: "Project", s: BLUE_HEADER },               // 2
      { v: "SDP", s: BLUE_HEADER },                   // 3
      { v: "Area", s: BLUE_HEADER },                  // 4
      { v: "Contraception Methods", s: BLUE_HEADER }, // 5

      { v: "Reasons for Drop Outs", s: BLUE_HEADER }, // 6
      { v: "", s: BLUE_HEADER },                      // 7
      { v: "", s: BLUE_HEADER },                      // 8
      { v: "", s: BLUE_HEADER },                      // 9
      { v: "", s: BLUE_HEADER },                      // 10
      { v: "", s: BLUE_HEADER },                      // 11

      { v: "Switched Method", s: BLUE_HEADER },       // 12
      { v: "", s: BLUE_HEADER },                      // 13
      { v: "", s: BLUE_HEADER },                      // 14
      { v: "", s: BLUE_HEADER },                      // 15
      { v: "", s: BLUE_HEADER },                      // 16
      { v: "", s: BLUE_HEADER },                      // 17
      { v: "", s: BLUE_HEADER },                      // 18

      { v: "Total", s: BLUE_HEADER },                 // 19
    ];


    /* =========================================================
       HEADER ROW 2
       ========================================================= */

    const headerRow2 = [

      { v: "", s: BLUE_HEADER }, // 0
      { v: "", s: BLUE_HEADER }, // 1
      { v: "", s: BLUE_HEADER }, // 2
      { v: "", s: BLUE_HEADER }, // 3
      { v: "", s: BLUE_HEADER }, // 4
      { v: "", s: BLUE_HEADER }, // 5

      /* Reasons */
      {
        v: "Complication / Side-effects",
        s: BLUE_HEADER,
      },

      {
        v: "Failure (Method/User)",
        s: BLUE_HEADER,
      },

      {
        v: "Personal Reasons",
        s: BLUE_HEADER,
      },

      {
        v: "Supplies related Reason",
        s: BLUE_HEADER,
      },

      {
        v: "Planned Pregnancy",
        s: BLUE_HEADER,
      },

      {
        v: "Lost to Follow-up",
        s: BLUE_HEADER,
      },

      /* Switched Method */
      {
        v: "Sterilisation (M+F)",
        s: BLUE_HEADER,
      },

      {
        v: "IUD",
        s: BLUE_HEADER,
      },

      {
        v: "LNG-IUS",
        s: BLUE_HEADER,
      },

      {
        v: "Implants",
        s: BLUE_HEADER,
      },

      {
        v: "Oral Pill",
        s: BLUE_HEADER,
      },

      {
        v: "Condom (M+F)",
        s: BLUE_HEADER,
      },

      {
        v: "Injectables",
        s: BLUE_HEADER,
      },

      /* Total */
      {
        v: "",
        s: BLUE_HEADER,
      },
    ];


    /* ================= COLUMN TOTALS ================= */

    const columnTotals = {};

    for (let i = 1; i <= 13; i++) {
      columnTotals[`RemarksDiscontinued${i}`] = 0;
    }

    columnTotals.Total = 0;


    /* ================= DATA ROWS ================= */

    const dataRows = rows.map((r, i) => {

      const alt =
        i % 2
          ? {
            fill: {
              fgColor: {
                rgb: "F0F0F0",
              },
            },
          }
          : {};


      /* =====================================================
         COLUMN TOTALS
  
         Only calculate the 13 report columns.
         Row Total has been completely removed.
         ===================================================== */

      for (let k = 1; k <= 13; k++) {

        const val = Number(
          r[`RemarksDiscontinued${k}`] || 0
        );

        columnTotals[
          `RemarksDiscontinued${k}`
        ] += val;
      }


      /* Total column */
      columnTotals.Total += Number(
        r.Total || 0
      );


      /* =====================================================
         DATA ROW
         ===================================================== */

      return [

        /* S.No. */
        {
          v: i + 1,
          s: alt,
        },

        { v: safe(r.Branch), s: alt },
        { v: safe(r.Project), s: alt },
        { v: safe(r.SDP), s: alt },
        { v: safe(r.Area), s: alt },
        { v: safe(r.Method), s: alt },


        /* ===================================================
           13 REPORT COLUMNS
           =================================================== */

        ...Array.from(
          { length: 13 },
          (_, x) => ({

            v: Number(
              r[`RemarksDiscontinued${x + 1}`] || 0
            ),

            t: "n",

            s: {
              ...alt,
              alignment: {
                horizontal: "right",
              },
            },

          })
        ),


        /* ===================================================
           TOTAL
           =================================================== */

        {
          v: Number(r.Total || 0),
          t: "n",
          s: alt,
        },

      ];
    });


    /* ================= TOTAL ROW ================= */

    const totalsRow = [

      {},
      {},
      {},
      {},
      {},

      {
        v: "Totals",
        s: {
          font: {
            bold: true,
          },
        },
      },


      /* =====================================================
         13 COLUMN TOTALS
         ===================================================== */

      ...Array.from(
        { length: 13 },
        (_, i) => ({

          v: columnTotals[
            `RemarksDiscontinued${i + 1}`
          ],

          t: "n",

          s: {
            font: {
              bold: true,
            },
          },

        })
      ),


      /* =====================================================
         TOTAL
         ===================================================== */

      {
        v: columnTotals.Total,
        t: "n",

        s: {
          font: {
            bold: true,
          },
        },
      },

    ];


    /* ================= SHEET DATA ================= */

    const wsData = [

      titleRow,

      dateRangeRow,

      branchRow,

      spacingRow,

      headerRow1,

      headerRow2,

      ...dataRows,

      totalsRow,

    ];


    /* ================= CREATE SHEET ================= */

    const ws = XLSX.utils.aoa_to_sheet(wsData);


    /* =========================================================
       MERGES
       ========================================================= */

    ws["!merges"] = [

      /* Title */
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: 1 },
      },


      /* =======================================================
         VERTICAL MERGES
         ======================================================= */

      {
        s: { r: 4, c: 0 },
        e: { r: 5, c: 0 },
      },

      {
        s: { r: 4, c: 1 },
        e: { r: 5, c: 1 },
      },

      {
        s: { r: 4, c: 2 },
        e: { r: 5, c: 2 },
      },

      {
        s: { r: 4, c: 3 },
        e: { r: 5, c: 3 },
      },

      {
        s: { r: 4, c: 4 },
        e: { r: 5, c: 4 },
      },

      {
        s: { r: 4, c: 5 },
        e: { r: 5, c: 5 },
      },


      /* =======================================================
         REASONS FOR DROP OUTS
         ======================================================= */

      {
        s: { r: 4, c: 6 },
        e: { r: 4, c: 11 },
      },


      /* =======================================================
         SWITCHED METHOD
         ======================================================= */

      {
        s: { r: 4, c: 12 },
        e: { r: 4, c: 18 },
      },


      /* =======================================================
         TOTAL
         ======================================================= */

      {
        s: { r: 4, c: 19 },
        e: { r: 5, c: 19 },
      },

    ];


    /* ================= COLUMN WIDTHS ================= */

    ws["!cols"] = [

      { width: 6 },   // S.No.
      { width: 18 },  // Branch
      { width: 20 },  // Project
      { width: 18 },  // SDP
      { width: 18 },  // Area
      { width: 18 },  // Method

      /* Reasons */
      { width: 22 },
      { width: 20 },
      { width: 20 },
      { width: 22 },
      { width: 20 },
      { width: 18 },

      /* Switched Method */
      { width: 18 },
      { width: 12 },
      { width: 12 },
      { width: 12 },
      { width: 12 },
      { width: 16 },
      { width: 14 },

      /* Total */
      { width: 10 },

    ];


    /* ================= ROW HEIGHTS ================= */

    ws["!rows"] = [

      { hpt: 24 }, // Title

      { hpt: 20 }, // Date

      { hpt: 20 }, // Filters

      { hpt: 10 }, // Spacer

      { hpt: 30 }, // Header row 1

      { hpt: 42 }, // Header row 2

      ...Array(rows.length).fill({
        hpt: 20,
      }),

      { hpt: 22 }, // Totals

    ];


    /* ================= BORDERS ================= */

    const range = XLSX.utils.decode_range(
      ws["!ref"]
    );

    for (
      let R = range.s.r;
      R <= range.e.r;
      ++R
    ) {

      for (
        let C = range.s.c;
        C <= range.e.c;
        ++C
      ) {

        const cell =
          ws[
          XLSX.utils.encode_cell({
            r: R,
            c: C,
          })
          ];

        if (cell) {

          cell.s = {

            ...cell.s,

            border: {

              top: {
                style: "thin",
              },

              bottom: {
                style: "thin",
              },

              left: {
                style: "thin",
              },

              right: {
                style: "thin",
              },

            },

          };

        }

      }

    }


    /* ================= WORKBOOK ================= */

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      wb,
      ws,
      "Drop Outs"
    );


    /* ================= EXPORT ================= */

    XLSX.writeFile(
      wb,
      "Drop_outs.xlsx"
    );

  };


  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    }); // Use A3 format
    const logoWidth = 30;
    const logoHeight = 14;
    doc.addImage(fpaiLogo, "JPEG", 10, 10, logoWidth, logoHeight);

    // Ensure DropoutsReportHeader is an array of objects with a title property
    //  const headers = DropoutsReportHeader.map((column) => column.title);
    const headers = [
      { content: "S.No.", rowSpan: 2 },
      { content: "Branch", rowSpan: 2 },
      { content: "Contraception Methods", rowSpan: 2 },
      { content: "Reasons for Drop Outs", colSpan: 6 },
      { content: "Switched Method", colSpan: 7 },
      { content: "Total", rowSpan: 2 },
    ];
    const subHeaders = [
      "Complication / Side-effects",
      "Failure (Method /User)/ Confirmed Pregnancy",
      "Personal Reasons-Fears, Difficult to Use, Objection",
      "Supplies related Reason-Difficult to Get Another Source",
      "Planned Pregnancy / Want child",
      "Lost to Follow-up",
      "Sterilisation (M+F)",
      "IUD",
      "LNG-IUS",
      "Implants",
      "Oral Pill",
      "Condom (M+F)",
      "Injectables",
      "Total",
    ];
    // Map bindDropoutData to the appropriate format for autoTable
    const data = bindDropoutData.map((rowData, index) => {
      return [
        index + 1,
        rowData.Branch,
        rowData.Method,
        rowData.RemarksDiscontinued1,
        rowData.RemarksDiscontinued2,
        rowData.RemarksDiscontinued3,
        rowData.RemarksDiscontinued4,
        rowData.RemarksDiscontinued5,
        rowData.RemarksDiscontinued6,
        rowData.RemarksDiscontinued7,
        rowData.RemarksDiscontinued8,
        rowData.RemarksDiscontinued9,
        rowData.RemarksDiscontinued10,
        rowData.RemarksDiscontinued11,
        rowData.RemarksDiscontinued12,
        rowData.RemarksDiscontinued13,
        rowData.Total,
      ];
    });

    // Create the table with headers and data
    doc.autoTable({
      head: [headers, subHeaders],
      body: data,
      startY: 30,
      styles: {
        fontSize: 7, // Reduced font size
        lineColor: "black",
        lineWidth: 0.2,
        halign: "center", // Align text to center
        valign: "middle", // Align text vertically in the middle
        cellPadding: 2, // Add padding to cells
        overflow: "linebreak", // Allow text to wrap within cells
      },
      headStyles: {
        fillColor: "#2d2d6e",
        textColor: [255, 255, 255],
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray color for alternate rows
      },
      columnStyles: {
        0: { cellWidth: 10 }, // Index column
        1: { cellWidth: "auto" }, // Auto adjust width
        2: { cellWidth: "auto" }, // Auto adjust width
        3: { cellWidth: "auto" }, // Auto adjust width
        4: { cellWidth: "auto" }, // Auto adjust width
        5: { cellWidth: "auto" }, // Auto adjust width
        6: { cellWidth: "auto" }, // Age
        7: { cellWidth: "auto" }, // Gender
        8: { cellWidth: "auto" }, // Auto adjust width
        9: { cellWidth: "auto" }, // Auto adjust width
        10: { cellWidth: "auto" }, // Auto adjust width
        11: { cellWidth: "auto" }, // Auto adjust width
        12: { cellWidth: "auto" }, // Auto adjust width
        13: { cellWidth: "auto" }, // Auto adjust width
        14: { cellWidth: "auto" }, // Auto adjust width
        15: { cellWidth: "auto" }, // Auto adjust width
        16: { cellWidth: "auto" }, // Auto adjust width
      },
    });

    doc.save("Drop_outs.pdf");
  };

  const BranchProjectFetchData = async () => {
    try {
      const userProfileDatas = userProfileState.userProfile;
      const [profile] = userProfileDatas;
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };
      const locationResponse = await BindPostAPI([data], "LocationAPI/GetLocation");

      const locationData = locationResponse.data.Table.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
      }));

      setBindBranchProjectDD(locationData);
    } catch (error) { }
  };

  const sdpChange = (updatedOptions) => {
    setArea("");
    setShowTable(false);
    setSDP(updatedOptions);
    setBindAreaDD([]);

    const SDPlabels = getSDPNames(updatedOptions);
    setSDPNamesList(SDPlabels);
  };
  const getSDPNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map((option) => bindSDP?.find((item) => item.value === option)?.label)
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };
  const brangeChange = (updatedOptions) => {
    setSDP("");
    setShowTable(false);
    setArea("");
    setBindSDP([]);
    setBindAreaDD([]);
    setBranchProject(updatedOptions);
    const branchProjectlabels = getBranchProjectsNames(updatedOptions);

    setBranchProjectNamesList(branchProjectlabels);
  };

  const getBranchProjectsNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map(
        (option) =>
          bindBranchProjectDD?.find((item) => item.value === option)?.label
      )
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  const areaChange = (updatedOptions) => {
    setArea("");
    setShowTable(false);
    setArea(updatedOptions);
    const arealabels = getAreaNames(updatedOptions);
    setAreaNamesList(arealabels);
  };
  const getAreaNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map((option) => bindArea?.find((item) => item.value === option)?.label)
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };
  return (
    <MainLayout pageName="4">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />

      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`Drop outs`}</div>
            </div>
            <div className={mainTable.grid3}>
              {userProfileDatas[0]?.MstOrganizationId == 1 && (
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Branch/Project"
                    filteredOptions={bindBranchProjectDD}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      branchProject?.length > 0 ? "More Selected" : "Select..."
                    }
                    name="branchProject"
                    selectedOptions={branchProject}
                    classDiv="relative w-full inline-block"
                    onChange={brangeChange}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {branchProjectError && (
                    <span className="text-red-500">{branchProjectError}</span>
                  )}
                </div>
              )}
              {(userProfileDatas[0]?.MstOrganizationId == 2 ||
                userProfileDatas[0]?.MstOrganizationId == 3) && (
                  <InputText
                    inputType="text"
                    title="Branch/Project"
                    classStar="text-red-500"
                    name="schoolName"
                    disabled="true"
                    content={branchName}
                    controlFunc={(e) => setBranchName(e.target.value)}
                  />
                )}
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="SDP"
                  filteredOptions={bindSDP}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={sdp?.length > 0 ? "More Selected" : "Select..."}
                  name="sdp"
                  selectedOptions={sdp}
                  classDiv="relative w-full inline-block"
                  onChange={sdpChange}
                  classLabel={mainTable.labelNoWrap}
                />
                {sdpError && <span className="text-red-500">{sdpError}</span>}
              </div>

              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Area"
                  filteredOptions={bindArea}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={area?.length > 0 ? "More Selected" : "Select..."}
                  name="area"
                  selectedOptions={area}
                  classDiv="relative w-full inline-block"
                  onChange={areaChange}
                  classLabel={mainTable.labelNoWrap}
                />
                {areaError && <span className="text-red-500">{areaError}</span>}
              </div>
            </div>
            <div class={mainTable.grid3}>
              <AutoDropDown
                // classStar="text-red-500"
                title="Project"
                options={bindProject}
                placeholder="Select"
                name="project"
                disabled={false}
                selectedOption={bindProject?.find(
                  (x) => x.value === project
                )}
                controlFunc={(value) => {
                  setProject(value.value);
                  setProject1(value.label);
                  setProjectError(""); // clear error on change
                }}
                controlFuncBlur={() => {
                  setProjectError(project ? "" : "Select Project");
                }}
                Class="custom-class"
                tabIndex={1}
              // errorMessage={projectError}
              />
              <InputText
                inputType="date"
                title="From"
                name="fromDate"
                content={fromDate}
                controlFunc={(e) => {
                  setShowTable(false);
                  setFromDate(e.target.value);
                }}
              />
              <InputText
                inputType="date"
                title="To"
                name="toDate"
                content={toDate}
                controlFunc={(e) => {
                  setShowTable(false);
                  setToDate(e.target.value);
                }}
              />
              {/* <div class="flex justify-start items-center mt-6">
                <button
                  type="button"
                  onClick={() => GoButton()}
                  className={mainTable.addButton}
                >
                  GO
                </button>
              </div> */}
            </div>
            <div className={mainTable.grid3}>
              <div></div>
              <div className="flex justify-center items-center mt-6">
                <button
                  type="button"
                  onClick={GoButton}
                  className={mainTable.addButton}
                >
                  GO
                </button>
              </div>
            </div>
          </div>
        </div>
        {showTable &&
          (bindDropoutData.length > 0 ? (
            <div className=" ">
              <ReportGridPage
                title=""
                header={DropoutsReportHeader}
                records={bindDropoutData}
                handleExport={handleExport}
                handlePDF={downloadPDF}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              No record found
            </div>
          ))}
      </div>
    </MainLayout>
  );
};

export default DropOutsReport;
